import axios from 'axios';
import { appUrl, smlUrl } from '../../../../../utils/config';
import { DESTROY_BACKDROP, FETCH_SPONSORS_FOR_CMO} from '../types';

export const fetchSponsorsForCmo = (data) => (dispatch) => {
  axios
    // .post(`${smlUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/saveInventoryStatusFilters`,data)
    .post(`${smlUrl}/sml/fetchSponsorsForCMO`,data)
    .then((res) => {
      dispatch({
        type: FETCH_SPONSORS_FOR_CMO,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.error("API Error:", err); // Log the error for debugging

      // Handle errors
      if (err?.response?.status === 404) {
        dispatch({
          type: FETCH_SPONSORS_FOR_CMO,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: FETCH_SPONSORS_FOR_CMO,
          payload: {
            status: false,
            errorDescription: "Something went wrong. Please contact support.",
          },
        });
      }
    });
};
